import React from "react";
import Laptop from "assets/laptop.jpg";
import { ABOUT_DATA } from "data";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <div className="w-full bg-white py-28 px-4" id="about">
      <h1 className="text-center text-4xl font-semibold mb-20">About Us</h1>
      <div className="max-w-[1240px] mx-auto grid md:grid-cols-2">
        <img
          className="w-[500px] mx-auto my-4"
          src={Laptop}
          alt="/"
          loading="lazy"
        />
        <div className="flex flex-col justify-center">
          {/* <p className="text-[#00df9a] font-bold ">DATA ANALYTICS DASHBOARD</p> */}
          <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-2">
            {ABOUT_DATA.header}
          </h1>
          <div>{ReactHtmlParser(ABOUT_DATA.description)}</div>
          <Link
            to="/about"
            className="bg-black text-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto md:mx-0 py-3"
          >
            <span className="flex justify-center">Read More</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
